<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content work_flow_wrap">
    <!-- <h1>{{ subTitle }}</h1> -->
    <div v-show="pageShow&&!showTaskDetail" :style="isPatchDownload ? 'padding-bottom:106px;' : ''">
      <div class="search-area">
        <el-row :gutter="24" >
          <el-col :span="6"
            ><div class="search-area-div" >应用公司</div>
            <el-select
              @change="handleChangeCompany"
              v-model="page.tenantGuid"
              placeholder="请选择"
              size="mini"
              class="ipt-sty"
              style="width: 260px"
              filterable
              clearable
            >
              <el-option
                v-for="item in sendTenantList"
                :key="item.guid"
                :label="item.tenantName"
                :value="item.guid"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6"
            ><div class="search-area-div" >应用部门</div>
            <el-select
              v-model="page.organisationGuid"
              filterable
              clearable
              placeholder="请选择"
              size="mini"
              class="ipt-sty"
              style="width: 260px"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6"
            ><div class="search-area-div" >问卷标题</div>
            <el-input class="ipt-sty"  v-model="page.surveyTitle" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="6" class="search-btn-box">
              <el-button size="mini" type="expand" @click="searchShow = !searchShow"><i :class="searchShow ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'"></i>{{searchShow ? '收起筛选':'更多筛选'}}</el-button>
              <el-button size="mini" type="info" @click="getList">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
        <div class="search-block mt15" v-if="searchShow">
          <el-row :gutter="24">
            <el-col :span="6"
              ><div class="search-area-div" >启用状态</div>
              <el-select v-model="page.surveyState" filterable placeholder="请选择" size="mini" class="ipt-sty" >
                <el-option
                  v-for="item in optionState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6"
              ><div class="search-area-div" >问卷来源</div>
              <el-select v-model="page.isShowPlatformTemplate" filterable placeholder="请选择" size="mini" class="ipt-sty" >
                <el-option
                  v-for="item in optionPlat"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6"
              ><div class="search-area-div" >是否关联任务包</div>
              <el-select v-model="page.isRelateTask" filterable placeholder="请选择" size="mini" class="ipt-sty" >
                <el-option
                  v-for="item in collectTaskOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6"
              ><div class="search-area-div" >发布状态</div>
              <el-select v-model="page.isDraft" filterable placeholder="请选择" size="mini" class="ipt-sty" >
                <el-option
                  v-for="item in optionDraft"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'" >
        <div class="button-area" style="padding-bottom:20px;">
          <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">添加问卷</el-button>
          <el-button icon="el-icon-plus" size="mini" type="info" @click="importQuestion(1)" >批量导入问卷</el-button>
          <el-button icon="el-icon-plus" size="mini" type="info" @click="importQuestion(2)">导入平台问卷</el-button>
          <el-button 
            class="fr"
            type="borderGreen"
            size="mini" 
            @click="showBatchDownload"
          >
            批量下载题目
          </el-button>
        </div>
        
        <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="height">
          <el-table-column v-if="isPatchDownload" width="55" header-align="center" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" :disabled="!canDownload(scope.row)" @change="() => handleCheckChange()"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="tenantName" label="应用公司" show-overflow-tooltip header-align="center" align="left" min-width="200">
            <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="organisationName" label="应用部门" width="120" header-align="center" align="left"  show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.organisationName?scope.row.organisationName.join() : '-' }}</template>
          </el-table-column>
          <el-table-column prop="surveyTitle" label="问卷标题" width="200" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.surveyTitle || '-' }}</template>
          </el-table-column>
          <el-table-column prop="isShowPlatformTemplate" label="问卷来源" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.isPlatformTemplate=='Y'?'平台':'药企'  }}
            </template>
          </el-table-column>
          <el-table-column prop="surveyExecuteRules" width="330" label="规则说明" header-align="left" align="left">
            <template slot-scope="scope">
              <template v-if="scope.row.surveyExecuteRules&&scope.row.surveyExecuteRules.length>0">
                <span v-if="scope.row.surveyExecuteRules.length==1">
                  <el-tooltip v-if="scope.row.surveyExecuteRules[0].ruleDesc.length>19" :content="scope.row.surveyExecuteRules[0].ruleDesc" placement="top-start" effect="light">
                    <span class="showTooltip">{{ scope.row.surveyExecuteRules[0].ruleDesc }}</span>
                  </el-tooltip>
                  <span v-else>{{ scope.row.surveyExecuteRules[0].ruleDesc }}</span>
                </span>
                <span v-else>
                  <el-tooltip placement="top-start" effect="light">
                    <div slot="content">
                      <div v-for="(rule,d) in getRuleList(scope.row.surveyExecuteRules)">
                        <p>{{d+1}}.{{ rule.ruleDesc }}</p>
                      </div>
                    </div>
                    <span class="showTooltip">{{ scope.row.surveyExecuteRules[0].ruleDesc }}({{ scope.row.surveyExecuteRules.length }})</span>
                  </el-tooltip>
                </span>
              </template>
              <template v-if="!scope.row.surveyExecuteRules">
                <span>-</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="surveyState"
            width="90px"
            label="启用状态"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="survey-state-yes" v-if="scope.row.surveyState == 'Y'&&scope.row.isDraft == 'N'">已启用</span>
              <span class="survey-state-no" v-if="scope.row.surveyState !== 'Y'&&scope.row.isDraft == 'N'">已禁用</span>
              <span v-if="scope.row.isDraft !== 'N'">-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="isDraft"
            width="86px"
            label="发布状态"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ getDraftStateText(scope.row.isDraft) }}</template>
          </el-table-column>
          <el-table-column
            prop="isRelateTask"
            width="110px"
            label="是否关联任务包"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.isRelateTask == 'Y' ? '已关联' : '未关联' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizApproveState"
            width="110px"
            label="最新流程类型"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.approveVO?.flowName || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="approveState"
            width="110px"
            label="审批状态"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
            <span 
              :class="getStateShow(scope.row.approveVO?.approveState)"
            >
              {{ scope.row.approveVO?.approveState | approveState }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="submitter"
            width="110px"
            label="提交人"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.approveVO?.staffName || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            width="110px"
            label="提交时间"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.approveVO?.createTime | getTime }}
            </template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            width="110px"
            label="更新人"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.updateUserName || '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            width="110px"
            label="更新时间"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.updateTime | getTime }}
            </template>
          </el-table-column>
          <el-table-column prop="inputTime" width="100" label="创建时间" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.inputTime | getDate }}</template>
          </el-table-column>
          <el-table-column prop="bank" width="265px" label="操作" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <a class="txt-color" @click="editVersion(scope.row, 0)">复制</a>
              <a 
                class="txt-color" 
                v-if="showEditBtn(scope.row)"
                @click="editVersion(scope.row, 1)"
              >
                编辑 
              </a>
              <!-- <a class="txt-color" @click="getCollectTaskList(scope.row,1)">编辑 ｜</a> -->
              <a class="txt-color" @click="getDetail(scope.row)">移动端预览</a>
              <a class="txt-color" v-if="scope.row.surveyState == 'Y'&&scope.row.isDraft == 'N'" @click="remindData(scope.row,'N',3)">设为禁用</a>
              <a class="txt-color" v-if="scope.row.surveyState == 'N'&&scope.row.isDraft == 'N'" @click="setDefault(scope.row,'Y')">设为启用</a>
              <a 
                class="txt-color" 
                v-if="scope.row.approveVO.approveState !== 'A'"
                @click="remindData(scope.row,'',2)"
                >
                <span class="fontC-red">删除</span>
              </a>
              <a class="txt-color" v-if="scope.row.isRelateTask=='Y'" @click="getCollectTaskList(scope.row,2)">查看关联任务包</a>
              <a class="txt-color" v-if="scope.row.surveyUrl" @click="showQRCode(scope.row)">问卷二维码</a>
            </template>
          </el-table-column>
        </el-table>
        
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10,20,50, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
      <div v-if="isPatchDownload" class="pitchAll">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ '全选' }} {{ `已选${checkList.length}个` }}</el-checkbox>
        <div class="pitchBtn">
          <div class="butt1" style="margin-left:10px" @click="batchDownload">确认下载</div>
          <div class="cancel-butt" @click="isPatchDownload = false">取消</div>
        </div>
      </div>
    </div>
    <div class="import-box" v-show="showTaskDetail">
      <!-- 标题 -->
      <div class="import-title">
        <div class="back" @click="closeTaskData">返回</div>
        <span>{{editRow.isPlatformTemplate=='Y'?'平台':editRow.tenantName}}-{{ editRow.surveyTitle }}-关联任务包信息</span>
      </div>
      <!-- 表格 -->
      <div class="back-color-fff content-main-box edit-main-box"  >
        <el-table
          :data="taskData"
          border
          style="width: 100%"
          :height="tableHeight"
          stripe 
          :header-cell-style="{background:'#f4f4f5'}"
        >
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="tenantName" label="公司名称" show-overflow-tooltip header-align="center" align="left" min-width="180">
            <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskNo" label="任务包编号" show-overflow-tooltip header-align="center" align="left" min-width="120">
            <template slot-scope="scope">{{ scope.row.taskNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskTitle" label="任务包标题" show-overflow-tooltip header-align="center" align="left" min-width="180">
            <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
          </el-table-column>
          <el-table-column prop="taskContentNameList" label="项目任务名称" header-align="center" align="left"  show-overflow-tooltip min-width="150">
            <template slot-scope="scope">{{ scope.row.taskContentNameList.length?scope.row.taskContentNameList.join() : '-' }}</template>
          </el-table-column>
          <el-table-column prop="startTime" width="180" label="执行时间" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.startTime | getDate }} - {{
            scope.row.endTime | getDate
          }}</template>
          </el-table-column>
          <el-table-column prop="sendTime" width="130" label="任务包发布时间" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.sendTime | getTime }}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :page-sizes="[10, 50, 100, 200]"
        :current-page="page1.pageIndex"
        :page-size="page1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page1.totalRows"
      >
      </el-pagination>
      
    </div>
    <!-- 导入 -->
    <el-dialog title="批量导入" :close-on-click-modal="false" :visible.sync="showImport" width="800px" class="importClass" @close="cancelImport">
      <el-steps :active="currentStep" align-center>
        <el-step title="上传文件"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>
      <div class="firstStep" v-if="currentStep == 0">
        <el-row>
          <el-col :span="6"> 下载模板： </el-col>
          <el-col :span="18">
            <div>
              <a :href="templateUrl" type="download" class="downloadTemplate">下载导入模板</a>
              <!-- <el-button type="info" @click="downloadTemplate" size="small">下载导入模板</el-button> -->
            </div>
            <div class="tipInfo">
              注意事项：<br />
              1、请先下载Excel模版，严格按照模板内容填入数据，再上传文件到系统；<br />
              2、若导入同公司、同部门、且问卷标题相同的内容，则信息将会覆盖；<br />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 导入文件： </el-col>
          <el-col :span="18">
            <div>
              <el-upload
                class="avatar-uploader"
                action="#"
                :limit="1"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadImage"
                accept=".xlsx,.xsl,.xls,.xlsm"
                multiple
                :file-list="fileList"
              >
              <!-- 
                :auto-upload="false" -->
                <span class="downloadTemplate" :loading="importLoading">点击上传文件</span>
                <!-- <el-button slot="trigger" size="small" type="primary" @click="remindUpload()">选取文件</el-button> -->
              </el-upload>
            </div>
            <div class="tipInfo">
              注意事项：<br />
              1、仅支持excel文件，大小&lt; =2M；<br />
              2、使用 Office 2010 及以上版本，避免出现乱码；<br />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="secondStep" v-if="currentStep == 1">
        <p class="line1">数据导入完成，请核对！</p>
        <p class="line2">
          共需导入<span> {{ importResult.total }} </span> 个问卷，导入成功 <span>{{ importResult.ok }} </span> 个
          <span v-if="importResult.subjectErrorQty>0 || importResult.error>0"
            >，失败<span> {{ importResult.error }} </span
            > 个，其中存在 {{importResult.subjectErrorQty}} 道错题</span>
        </p>
        <p class="line3" @click="downFailData" v-if="importResult.subjectErrorQty>0 || importResult.error>0">下载失败原因</p>
      </div>
      <div slot="footer" class="dialog-footer" v-if="currentStep == 0">
        <el-button @click="cancelImport" size="small">取 消</el-button>
        <el-button type="info" @click="confirmImport" :loading="importLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 结束 -->
    <!-- 移动端预览 -->
    <mobile-survey
      :subjectList="pageForm.subjectList"
      :title="pageForm.surveyTitle"
      :desc="pageForm.surveyText||pageForm.surveyDesc"
      :videoUrl="pageForm.videoUrl"
      ref="mobileSurvey"
      @pageClose="pageClose"
    ></mobile-survey>
    <!-- 修改问卷 -->
    <el-dialog title="修改问卷模式"  :visible.sync="editVisible" custom-class="editClass" width="640px" @close="editVisible=false">
      
        <div class="edit-card">
          <div class="edit-card-item" :class="cardMode == 1 ?'active':''" @click="editMode(1)">
            <div :class="cardMode == 1 ?'card1-active':'card1'"></div>
            <div class="card-content">
              <p class="title">保留历史答卷</p>
              <span>修改受限制只影响新提交的答卷</span>
            </div>
          </div>
          <div class="edit-card-item" :class="cardMode == 2 ?'active':''" @click="editMode(2)">
            <div :class="cardMode == 2 ?'card2-active':'card2'"></div>
            <div class="card-content">
              <p class="title">复制此问卷并去编辑</p>
              <span>原始问卷不受任何影响</span>
            </div>
          </div>
        </div>
        <div class="edit-content" v-if="cardMode == 1">
          <p>1、该问卷已派发 {{ taskData.length }} 个任务包，<span style="color: #4FA1A4;" @click="toSeeTaskData">点击查看详情</span>；</p>
          <p>2、只能修改问卷模板的细节，例如：<span style="color: red;">新增和减少某些题目的自定义选项、修改自定义选项文字、修改必填或非必填、题目类型中的单选和多选可以互换、以及修改交互方式；</span></p>
          <p>3、修改后<span style="color: red;">直只影响新提交的问卷，历史答卷不会更改</span>；</p>
          <p>4、不能对问卷做以下操作：修改是否平台模版、应用公司、应用部门、新增题目、删除题目、修改题目标题、移动题目、更换题目类型（除了单选和多选可以互换）、题目分类、字典名称等。</p>
        </div>
        <div class="edit-content" v-if="cardMode == 2">
          <p>复制一份题目完全一致的新问卷，对复制的问卷进行编辑，不会影响到原始问卷的题目</p>
        </div>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="editVisible=false" size="small">取 消</el-button>
          <el-button type="info" @click="editVersion()" size="small">确 定</el-button>
        </div>
      
    </el-dialog>
    <QuestionnaireQRCode
      ref="QuestionnaireQRCodeRef"
    />
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import { getSurveyDetail } from '@/api/msSalesPerformService';
import store from '@/store';
import qs from 'qs';
import mobileSurvey from '@/components/mobileSurvey.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import { get } from 'lodash';
import JSZip from 'jszip';
import QuestionnaireQRCode from './components/QuestionnaireQRCode.vue';
export default {
  components: {
    mobileSurvey,
    QuestionnaireQRCode,
  },
  data() {
    return {
      showImport1:false,
      tableHeight: window.innerHeight - 290,
      searchShow:false,
      height: window.innerHeight - 280,
      contentMainHeight: window.innerHeight - 214,
      num:1,
      templateUrl: window.location.origin + '/问卷导入模板.xlsx',
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      optionState:[
        {
          label:'已启用',
          value:'Y',
        },
        {
          label:'已禁用',
          value:'N',
        }
      ],
      optionPlat:[
        {
          label:'全部',
          value:null,
        },
        {
          label:'平台',
          value:'Y',
        },
        {
          label:'药企',
          value:'N',
        }
      ],
      collectTaskOption:[
        {
          label:'全部',
          value:null,
        },
        {
          label:'已关联',
          value:'Y',
        },
        {
          label:'未关联',
          value:'N',
        }
      ],
      optionDraft:[
        {
          label: '全部',
          value: null,
        },
        {
          label: '草稿中',
          value: 'Y',
        },
        {
          label: '已发布',
          value: 'N',
        }
      ],
      tableLoading:false,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        // functionGuid: this.$route.query.functionGuid,
        surveyTitle:"",
        surveyState:null,
        tenantGuid: '',
        organisationGuid: '',
        isShowPlatformTemplate:null,
        isRelateTask:null,//是否关联任务包
        taskState: ["已派发", "部分结算", "已结算"],
        serviceTenantGuid: localStorage.guid

      },
      functionCode: '',
      functionName: '',
      functionDesc: '',
      guid: '',
      right: 'right',
      tableData: [],
      sendTenantList: [],
      organisationList: [],
      subTitle: '',
      value: '',
      //批量导入
      showImport: false,
      currentStep: 0,
      importResult: '',
      importLoading: false,
      fileList: [], //上传的文件
      importType:1,
      pageForm: {
        surveyTitle: null,
        surveyDesc: null,
        surveyText:null,
        subjectList: [],
      },
      pageShow:true,
      editRow:{},
      messageTips:"",
      editVisible:false,
      showTaskDetail:false,
      taskData:[],//关联任务包列表
      page1: {//关联任务包列表
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        
      },
      cardMode:1,//修改问卷模式
      toSeeFlg:false,//从问卷模板弹框进入的关联任务包列表
      isPatchDownload: false,
      checkAll: false,
      isIndeterminate: false,
      currentRow: {}, // 当前选中的行数据
    };
  },
  computed: {
    checkList() {
      return this.tableData.filter(item => item.checked === true);
    },
  },
  created() {
    this.subTitle = localStorage.threeLevels + '功能配置';
    this.getList();
    this.getSendTenantList();
    
  },
  activated(){
    this.getList();
  },
  deactivated() {
    this.isPatchDownload = false;
    this.tableData.forEach(row => {
      row.checked = false;
    });
    this.checkAll = false;
    this.isIndeterminate = false;
  },
  watch: {
    searchShow(val, oldVal) {
      if(val) {
        this.height = window.innerHeight - 330;
        this.contentMainHeight = window.innerHeight - 264;
        return;
      }
      if(!val) {
        this.height = window.innerHeight - 280;
        this.contentMainHeight = window.innerHeight - 214;
        return;
      }
    },
  },
  methods: {
    showEditBtn(row) {
      const userId = localStorage.userId;
      // 产品和测试说去掉人的判断
      // if (row.createUserId != userId) {
      //   return false
      // }
      // 草稿可以编辑
      if (row.isDraft == 'Y') {
        return true
      }
      // 已通过/驳回/撤销/草稿 可以编辑
      const approveStateList = ['Y', 'R', 'C', 'N']
      if (approveStateList.includes(row.approveVO?.approveState)) {
        return true
      }
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    getDraftStateText(val) {
      const draftStateMap = {
        N: '已发布',
        Y: '草稿中',
      };
      return draftStateMap[val] || '-';
    },
    getRuleList(arr){
      let list=[]
      if(arr.length>0){
        list=arr.slice(0,3)
      }
      return list
    },
    // 判断该行是否允许下载：新增流程只允许审批通过，修改流程允许审批通过/驳回/撤销
    canDownload(row) {
      const approveState = row.approveVO?.approveState;
      // 审批通过/驳回/撤销 状态
      const validStates = ['Y', 'R', 'C'];
      if (!validStates.includes(approveState)) {
        return false;
      }
      // 新增流程
      if (row.approveVO?.flowType == '00042') {
        return approveState == 'Y';
      }
      return true;
    },
    // 单个勾选框变化时，更新全选按钮状态（半选/全选）
    handleCheckChange() {
      let checkedLen = this.checkList.length;
      let downloadableLen = this.tableData.filter(item => this.canDownload(item)).length;
      this.isIndeterminate = checkedLen > 0 && checkedLen < downloadableLen;
      this.checkAll = checkedLen === downloadableLen;
    },
    // 全选按钮点击时，只操作允许下载的数据
    handleCheckAllChange() {
      let val = this.checkAll;
      this.tableData.forEach(row => {
        if (this.canDownload(row)) {
          row.checked = val;
        }
      });
      this.isIndeterminate = false;
    },
    showBatchDownload() {
      this.isPatchDownload = !this.isPatchDownload;
      if (!this.isPatchDownload) {
        this.tableData.forEach(row => {
          row.checked = false;
        });
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    async batchDownload() {
      let checkedList = this.checkList;
      if (checkedList.length === 0) {
        this.$message.warning('请先勾选需要下载的问卷');
        return;
      }
      try {
        await this.$confirm('确定下载问卷模版吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.fullscreenLoading = true;
        let guids = checkedList.map(item => item.guid);
        let res = await this.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/export/excel-template-list`, guids);
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = res.data.data || [];
          if (list.length === 0) {
            this.$message.warning('无题目下载');
            return;
          }
          if (list.length === 1) {
            this.reportJx(list[0].colNames, list[0].datas, list[0].sheetName, list[0].fileNam);
          } else {
            let now = this.$moment(new Date()).format('YYYYMMDDHHmmss');
            let zip = new JSZip();
            for (let item of list) {
              let excelRes = await this.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
                colNames: item.colNames,
                datas: item.datas,
                sheetName: item.sheetName,
                fileNam: item.fileNam,
              });
              let name = `${item.fileNam || item.sheetName}_题目表_${now}.xlsx`;
              zip.file(name, excelRes.data, { binary: true });
            }
            let blob = await zip.generateAsync({ type: 'blob' });
            const link = document.createElement('a');
            link.download = `问卷表_${now}.zip`;
            link.href = URL.createObjectURL(blob);
            link.click();
          }
          this.isPatchDownload = false;
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (e) {
        // $confirm取消或接口异常
      } finally {
        this.fullscreenLoading = false;
      }
    },
    toSeeTaskData(){//点击查看
      this.showTaskDetail=true;
      this.editVisible=false
      this.toSeeFlg=true
    },
    closeTaskData(){
      this.editVisible=this.toSeeFlg?true:false
      this.toSeeFlg=false
      this.showTaskDetail=false
    },
    editMode(type){
      this.cardMode=type
    },
    getCollectTaskList(row,flg){//1编辑 2查看 3修改page
      if(flg==1&&row.isRelateTask=='N'){//没有关联任务包，直接编辑
        this.editVersion(row,1)
        return
      }
      this.editRow=row
      if(flg==1){//点击编辑
        this.cardMode=1
        this.editVisible=true
      }else if(flg==2){//查看关联任务包
        this.showTaskDetail=true
      }
      if(flg!==3){
        this.page1.pageIndex=1
        this.page1.pageSize=50
      }
      let query = {
        surveyTenantGuid:row.guid,
        pageIndex: this.page1.pageIndex,
        pageSize: this.page1.pageSize,
        state: ["已派发", "部分结算", "已结算"],
      }
      
      //获取任务包
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-task-by-survey`,query)
      .then((res) => {
        if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
          console.log('res',res.data.data.records);
          this.taskData=res.data.data.records||[]
          this.page1.totalPage = res.data.data.totalPages;
          this.page1.totalRows = res.data.data.totalRows;
          if(flg==1){//点击编辑
            this.cardMode=1
            this.editVisible=true
          }else if(flg==2){//查看关联任务包
            this.showTaskDetail=true
          }
        }else {
          this.$message.error(res.data.msg);
        }
      })
      
    },
    pageClose(val) {
      this.pageShow = true;
    },
    getDetail(row) {
      let self = this;
      self.tableLoading = true;
      getSurveyDetail({
        guid: row.guid,
      }).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            let data = res.data.data;
            
            self.pageForm.surveyTitle = data.surveyTitle;
            self.pageForm.surveyDesc = data.surveyDesc;
            self.pageForm.surveyText = data.surveyText;
            self.pageForm.subjectList = data.subjectList ? data.subjectList : [];
            self.pageForm.videoUrl = data.videoUrl;
            // 问卷题目配置
            if(self.pageForm.subjectList.length>0){
              self.pageForm.subjectList.forEach(item=>{
                if((item.subjectType == '单选题'||item.subjectType == '多选题')&&!item.subjectItemType){
                  item.subjectItemType='1'
                  item.interactType='1'
                }
              })
            }
            this.mobileView()
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //移动端预览
    mobileView() {
      console.log('this.pageForm',this.pageForm);
      if (!this.pageForm.surveyTitle) {
        this.$message.error('请填写问卷标题');
        return;
      }
      if (!this.pageForm.surveyDesc) {
        this.$message.error('请填写问卷描述');
        return;
      }
      if (!this.pageForm.subjectList.length) {
        this.$message.error('请添加问卷题目');
        return;
      }
      this.pageShow = false;
      this.$refs.mobileSurvey.mobileShow = true;
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        functionGuid: this.$route.query.functionGuid,
        tenantGuid: null,
        organisationGuid: null,
        isShowPlatformTemplate:null,
        isRelateTask:null,
        taskState: ["已派发", "部分结算", "已结算"],

      };
      this.getList();
    },
    //新增
    addVersion() {
      let path = '/questionnaireAdd';
      let query = {};
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      this.$router.push({
        path
      });
    },
    //编辑
    editVersion(detail, type) {//0复制，1编辑
      let astrictEdit = 0;//限制修改
      if(!detail){//从修改问卷模式进入的
        this.editVisible=false
        detail=this.editRow
        type=this.cardMode==1?1:0
        if(type==1){
          astrictEdit=1
        }
      }
      // 驳回/撤销状态：根据之前的审批流类型决定走新增审批流还是编辑审批流
      if (type == 1 && ['R', 'C'].includes(detail.approveVO?.approveState)) {
        if (detail.approveVO?.flowType == '00042') {
          // 原先是新增审批被驳回/撤销，走重新提交（新增审批流）
          type = 3;
        }
        // 原先是编辑审批被驳回/撤销，走编辑流程（编辑审批流），type保持1
      }
      let query = {
        guid: detail.guid,
        type,
        approveVO: detail.approveVO ? JSON.stringify(detail.approveVO) : '',
      };
      let path = '/questionnaireAdd';
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      this.$router.push({
        path,
        query,
      });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      // self.page.serviceTenantGuid = localStorage.guid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records.map(item => {
            // 没有返回审批状态
            const approveVO = item.approveVO || {
              approveState: item.isDraft === 'Y' ? 'N' : (item.bizApproveState == 'Y' || item.bizApproveState == 'N' ? 'Y' : 'N'),
            }
            return {
              ...item,
              approveVO,
              checked: false,
            }
          });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 拦截提醒校验
    remindData(row,flg,from) {
      let that = this;
      console.log('校验',row,row.isDraft);
      if(from==1 && row.isDraft=='Y'){
        // 草稿的编辑
        this.editVersion(row,1)
        return
      }  
      let query={
        guid:row.guid,
        surveyTitle:row.surveyTitle,
        tenantGuid:row.tenantGuid,
        dataFrom:from,
      }
      that.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/check-task-publish`,query)
      .then((res) => {
        if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
          console.log('res',res.data.data);
          if(res.data.data){
            if(from==1){//换一个新接口，获取关联到的任务包
              this.editRow=row
              this.messageTips=res.data.data
              this.cardMode=1
              this.editVisible=true
              console.log('this.cardMode',this.cardMode);
              
            }else{
              this.$confirm(res.data.data, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                if(from==3){
                  // 设为禁用
                  this.setDefault(row,flg,1)
                }else if(from==2){
                  // 删除
                  this.delVersion(row,1)
                }
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消操作'
                });
              });
            }
            
          }else{
            if(from==3){
              // 设为禁用
              this.setDefault(row,flg)
            }else if(from==2){
              // 删除
              this.delVersion(row)
            }else if(from==1){
              // 编辑
              this.editVersion(row,1)
            } 
          }
          
        }else {
          that.$message.error(res.data.msg);
        }
      })
      
      
    },
    
    //设置禁用启用
    setDefault(row,state,flg) {
      // flg为1已经出现过校验提示
      let self = this;
      let query = {
        guid:row.guid,
        surveyState:state,
        // tenantGuid:row.tenantGuid,
        // tenantName:row.tenantName,
        // isDraft:state
      }
      let tip = '';
      if(state == 'N'){
        tip = '禁用后，该问卷将在手机端无法使用，确定操作吗？'
      }else{
        tip = '启用后，该问卷会应用在手机端哦，确定操作吗？'
      }
      if(flg==1){
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/set-state`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('设置成功');
              self.getList();
              // self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }else{
        self
        .$confirm(tip, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
          .postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/set-state`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('设置成功');
              self.getList();
              // self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
      }
      
    },
    delVersion(row,flg) {
      // flg为1已经出现过校验提示
      var self = this;
      var req = [row.guid];

      // if(row.surveyState == 'Y'&&row.isDraft == 'N'){
      //   self.$message.error('问卷已发布，不能删除');
      //   return
      // }
      if(flg==1){
        self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/del`, req).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }else{
        self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/del`, req).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        }).catch(()=>{
          
        });
      }
     
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    handleSizeChange1(val) {
      let self = this;
      self.page1.pageSize = val;
      this.getCollectTaskList(this.editRow,3);
    },
    handleCurrentChange1(val) {
      let self = this;
      self.page1.pageIndex = val;
      this.getCollectTaskList(this.editRow,3);
    },
    getSendTenantList() {
      let self = this;
      let query = {
        enterpriseCates: [...this.$getValueListByKey('上游客户分类'), "9901"],
        pageIndex:1,
        pageSize:-1
      };
      self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleChangeCompany(v) {
      let self = this;
      self.page.organisationGuid = '';
      if(!v)return
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          self.exportSettingLoading = false;
          self.showExportHead = false;
          let blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    //导入-上传文件
    uploadImage(file) {
      console.log('upload');
      
      let formData = new FormData();
      formData.append('file', file.file, file.filename);
      this.importLoading = true;
      let progressGuid = this.generateUUID();
      let url=`/${serverConfig.msSalesPerformService}/survey/tenant/check-import-task-publish?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`
      if(this.importType==2){
        url=`/${serverConfig.msSalesPerformService}/survey/tenant/check-platform-import-task-publish?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`
      }
      this.api
        .postFile(
          url,
          formData,
        )
        .then((res) => {
          this.importLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log('re',this.importType,res);
            if(!res.data.data){
              let importUrl=`/${serverConfig.msSalesPerformService}/survey/tenant/import?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`
              if(this.importType==2){
                importUrl=`/${serverConfig.msSalesPerformService}/survey/tenant/import-platform?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`
              }
              this.api .postFile(
                importUrl,
                formData,
              )
              .then((res) => {
                this.importLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  this.importResult = res.data.data;
                  this.$message.success('上传成功');
                } else {
                  this.$message.error(res.data.msg);
                }
              }).catch(() => {
                this.$message('上传失败,请重新上传');
              });
            }else{
              this.$confirm(res.data.data, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let importUrl=`/${serverConfig.msSalesPerformService}/survey/tenant/import?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`
                if(this.importType==2){
                  importUrl=`/${serverConfig.msSalesPerformService}/survey/tenant/import-platform?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`
                }
                this.api .postFile(
                  importUrl,
                  formData,
                ) .then((res) => {
                  this.importLoading = false;
                  if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.importResult = res.data.data;
                    this.$message.success('上传成功');
                  } else {
                    this.$message.error(res.data.msg);
                  }
                }).catch(() => {
                  this.$message('上传失败,请重新上传');
                });
              }).catch(() => {
                // 把文件删掉
                this.fileList=[]
                this.$message({
                  type: 'info',
                  message: '已取消操作'
                });
              });
            }
            // this.importResult = res.data.data;
            // this.$message.success('上传成功');
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$message('上传失败,请重新上传');
        });
      // this.api
      //   .postFile(
      //     `/${serverConfig.msSalesPerformService}/survey/tenant/import?tenantGuid=${this.$store.state.guid}&progressGuid=${progressGuid}`,
      //     formData,
      //   )
      //   .then((res) => {
      //     this.importLoading = false;
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.importResult = res.data.data;
      //       this.$message.success('上传成功');
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //   })
      //   .catch(() => {
      //     this.$message('上传失败,请重新上传');
      //   });
    },
    //导入-上传前校验
    beforeAvatarUpload(file) {
      console.log('bef');
      
      let testmsg = file.name ? file.name.split('.')[1] : '';
      const isJPG = testmsg === 'xls' || testmsg === 'xlsx'||testmsg === 'xlsm';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('文件格式不正确!');
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过2MB!');
      }
      return isJPG && isLt2M;
    },
    //导入-生成progressGuid
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    //导入-取消
    cancelImport() {
      this.showImport = false;
      this.importResult = '';
      this.currentStep = 0;
      this.fileList = [];
      this.getList();
    },
    //导入-确定
    confirmImport() {
      if (this.importResult) {
        this.currentStep = 1;
        this.fileList = [];
      } else if (this.fileList.length == 0) {
        this.$message.error('请选择文件！');
      } else {
        this.$message.error('上传失败！');
      }
    },
    //导入-下载导入失败数据
    downFailData() {
      let params = {
        guid: '',
        tenantGuid: this.$store.state.guid,
      };
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/import/get-error-report`, params)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    importQuestion(flg){//2为平台问卷
      this.importType=flg
      let str=flg==2?'/平台问卷导入模板.xlsx':'/问卷导入模板.xlsx'
      this.templateUrl=window.location.origin + str
      this.showImport = true
    },
    showQRCode(row) {
      this.currentRow = row;
      const data = {
        surveyUrl: this.currentRow.surveyUrl,
        surveyTitle: this.currentRow.surveyTitle,
      }
      this.$refs.QuestionnaireQRCodeRef.open(data);
    },
  },
};
</script> 
<style lang="less" scoped>
a.txt-color + a.txt-color::before {
  content: "|";
  display: inline-block;
  margin: 0 4px;
}


  .showTooltip{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .content h1 {
    margin: 0;
    margin-bottom: 16px;
    font-size: 18px;
  }
  .import-title {
    background: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 16px;
    margin-bottom: 4px;
    span{
      font-size: 16px;
      margin-left: 16px;
    }
  }
  .import-title .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
  .edit-main-box{
    height: calc(100vh - 290px);
    overflow-y: auto;
    padding: 28px;
  }
  .el-table /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
  }
  .el-range-editor.el-input__inner {
    padding: 0px;
  }
  /deep/ .el-checkbox__label {
    /* display: none; */
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }
  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }
  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }
  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }
  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }
  /* 导入 */
  .importClass .firstStep {
    text-align: left;
    margin-top: 50px;
  }

  .importClass .firstStep .el-row {
    margin-bottom: 50px;
  }

  .importClass .firstStep .el-col-6 {
    text-align: right;
  }

  .importClass .firstStep .tipInfo {
    line-height: 26px;
    color: #999;
    margin-top: 10px;
  }

  .importClass .secondStep {
    margin-top: 50px;
    height: 290px;
  }

  .importClass .secondStep .line1 {
    font-size: 20px;
  }

  .importClass .secondStep .line2 {
    font-size: 16px;
  }

  .importClass .secondStep .line2 span {
    color: #4fa1a4;
  }

  .importClass .secondStep .line3 {
    text-decoration: underline;
    cursor: pointer;
  }
  .downloadTemplate {
    color: #fff;
    background: #4fa1a4;
    padding: 9px 15px;
    border-radius: 3px;
    font-size: 12px;
    text-decoration: none;
    display: inline-block;
  }
  .survey-state-yes{
    display: inline-block;
    width: 56px;
    height: 24px;
    color: #649FA4;
    font-size: 12px;
    background: rgba(234, 246, 247, 0.39);
    border: 1px solid #B0D0D3;
    border-radius: 2px;
  }
  .survey-state-no{
    display: inline-block;
    width: 56px;
    height: 24px;
    color: #FF2121;
    font-size: 12px;
    background: rgba(255, 244, 244, 0.39);
    border: 1px solid #FFDEDE;
    border-radius: 2px;
  }
  /deep/.el-progress{
    display: flex;
  }
  /deep/.el-progress__text{
    flex-shrink: 0;
  }
  .search-area-div{
    flex-shrink: 0;
    margin-right: 4px;
    width: 96px;
  }
  .ipt-sty{
    flex: 1;
  }
  .el-col-6{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-8{
    display: flex;
    margin-bottom: 15px;
    justify-content: flex-end;
  }
  .editClass{
    background-image: url("../../assets/icon/card_bg.png");
    background-size: 100% ;
    background-repeat: no-repeat;
    .edit-card{
      display: flex;
      justify-content: space-between;
      .active{
        background: #EBF6F7;
        border: 1px solid rgba(79,161,164,1);
      }
    }
    .edit-card-item{
      width: 280px;
      height: 88px;
      background: #FFFFFF;
      border: 1px solid rgba(217,217,217,1);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .card-content{
        .title{
          font-size: 16px;
          color: #212121;
          letter-spacing: 0;
          line-height: 24px;
          font-weight: 600;
          margin: 0;
          text-align: left;
        }
      }
    }
    .card1{
      background: url('../../assets/icon/card1.png') no-repeat left center !important;
      background-size: 40px 40px !important;
      width: 40px;
      height: 40px;
      margin: 0 16px;
    }
    .card1-active{
      background: url('../../assets/icon/card1_ac.png') no-repeat left center !important;
      background-size: 40px 40px !important;
      width: 40px;
      height: 40px;
      margin: 0 16px;
    }
    .card2{
      background: url('../../assets/icon/card2.png') no-repeat left center !important;
      background-size: 40px 40px !important;
      width: 40px;
      height: 40px;
      margin: 0 16px;
    }
    .card2-active{
      background: url('../../assets/icon/card2_ac.png') no-repeat left center !important;
      background-size: 40px 40px !important;
      width: 40px;
      height: 40px;
      margin: 0 16px;
    }
    .edit-content{
      text-align: left;
      height: 206px;
      padding: 20px 0 ;
      p{
        margin: 7px 0;
        line-height: 21px;
      }
    }
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  .pitchAll {
    display: flex;
    align-items: center;
    width: calc(100% - 283px);
    background: #fff;
    height: 96px;
    padding: 0 20px;
    position: fixed;
    bottom: 0;
    box-shadow: 2px 2px 10px 4px rgba(0, 0, 0, 0.2);
    z-index: 999;
  }
  .pitchBtn {
    flex: 1;
    text-align: center;
  }
  .pitchBtn .butt1 {
    height: 32px;
    line-height: 32px;
    width: 110px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    z-index: 100;
    background: #ebf6f7;
    border: 1px solid #4fa1a4;
    color: #4fa1a4;
  }
  .cancel-butt {
    cursor: pointer;
    height: 32px;
    line-height: 32px;
    width: 110px;
    text-align: center;
    display: inline-block;
    background: #fff;
    border: 1px solid #c1c1c1;
    color: #232323;
    margin-top: 0;
    margin-left: 28px;
  }

</style>
<style>
.editClass{
  background-image: url("../../assets/icon/card_bg.png");
  background-size: 100% ;
  background-repeat: no-repeat;
}
</style>